import {Component} from "@angular/core";
import {OrderProcessorSearchModel} from "../order-processor-search.model";
import {OrderProcessorEntityModel} from "../order-processor-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-order-processor-search-page",
    templateUrl: "./order-processor-search-page.component.html",
    providers: [provideSearchModel(OrderProcessorSearchModel), provideEntityModel(OrderProcessorEntityModel)]

})
export class OrderProcessorSearchPageComponent extends AbstractSearchPage {

}
